<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconCheckmark_24"
>
    <path
        d="M9.109 19.44c-.384 0-.768-.146-1.061-.439l-5.972-5.972a1.5 1.5 0 1 1 2.121-2.121l4.912 4.911L19.96 4.967a1.5 1.5 0 1 1 2.121 2.121L10.169 19c-.293.293-.676.44-1.06.44Z"
        fill="currentColor"
    />
</svg>
